<script setup>
import { ref, computed, onMounted } from 'vue';

const props = defineProps({
  totalNum: { type: Number, required: true }
});

// モーダルの開閉状態を管理
const isOpen = ref(false);
// aria-hidden の値を計算
const ariaHidden = computed(() => !isOpen.value ? 'true' : 'false');

onMounted(() => {
  const modalElement = document.getElementById('searchNumOverModal');

  if(modalElement) {
    // モーダルが表示されたとき
    modalElement.addEventListener('shown.bs.modal', () => {
      isOpen.value = true;
    })

    // モーダルが閉じるとき
    modalElement.addEventListener('hide.bs.modal', () => {
      // モーダルないのすべてのフォーカス可能な要素からフォーカスを外す
      const focusedElement = modalElement.querySelector(':focus');
      if(focusedElement) {
        focusedElement.blur();
      }
    });
  }
});
</script>

<template>
  <div class="modal com_modal2 fade" id="searchNumOverModal" tabindex="-1" aria-hidden="ariaHidden">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">

        <div class="modal-header">
          <button type="button" class="btn-close"
            data-bs-dismiss="modal" aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">

          <h3 class="com_fs18 com_strong1 com_center1">
            検索結果が40000件を超えています
          </h3>

          <p class="com_fs14 com_center1 com_mgb0">
            検索結果は {{ totalNum }} 件です。<br>
            40000件を超えていますので、<br class="dsp-s">
            検索条件を絞り込んで再検索してください。
          </p>
        </div>

        <div class="modal-footer">
          <button type="button"
            class="btn com_btn2 wd1"
            data-bs-dismiss="modal"
          >
            再検索する
          </button>
        </div>

      </div>
    </div>
  </div>
</template>
